import { isAllowed } from "../../../api/access/decisions";
import { chosenProjectDecision, useProjects } from "../../../projects/projectContext";
import { appPaths } from "../../../shared/routing/appPaths";
import { useThreadPreparation } from "../../threads/prepare";
import { useCorpusSelection } from "../corpus/corpusSelectionContext";

/**
 * Importieren (web-app.md WA-12): opens the import's preparation in the Thread view beside
 * Documents, for the corpus worked in. `null` while no project is chosen or the person may
 * not propose changes in it.
 */
export function useImportPreparation(): (() => void) | null {
  const projects = useProjects();
  const { selectedCorpus } = useCorpusSelection();
  const { prepare } = useThreadPreparation();
  const projectId = projects.selectedProjectId;
  if (projectId === null || !isAllowed(chosenProjectDecision(projects, "propose_change"))) {
    return null;
  }
  return () => {
    prepare({ kind: "import", projectId, corpusId: selectedCorpus?.corpusId ?? null, returnTo: appPaths.sources() });
  };
}
